export const DatabaseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
    >
      <path
        d="M1 5v10c0 2.21 3.582 4 8 4s8-1.79 8-4V5M1 5c0 2.21 3.582 4 8 4s8-1.79 8-4M1 5c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
        stroke="currentColor"
        strokeWidth="1.75"
      />
    </svg>
  );
};
